import React, { createContext, useState } from "react";

export const SearchCustomerSegmentContext = createContext({});

export const initialSearchValues = {
  currentCustomerId: "",
  factoryName: "",
  typeOfEstate: [],
  customerGroupByEstateType: [],
  yearOfBudget: [],
  monthOfBudget: [],
  customerGroupByAge: [],
  customerGroupByRegion: [],
  waterConsumptionMin: "",
  waterConsumptionMax: "",
  areaSizeByRaiMin: "",
  areaSizeByRaiMax: "",
  areaSizeByNganMin: "",
  areaSizeByNganMax: "",
  areaSizeByWaMin: "",
  areaSizeByWaMax: "",
  areaSizeByMetersMin: "",
  areaSizeByMetersMax: "",
  buyOrRentLand: "",
  productAndServiceWant: "",
  supportWant: "",
  transactionWant: "",
  crmExpected: "",
  lineOfWorkId: [],
};

export const initialPageValues = {
  page: 0,
  pageSize: 1,
  total: 0,
  totalPage: 0,
  // sortBy: "currentCustomerId",
  sortBy: "createDate",
  sortDirection: "DESC",
};

const SearchCustomerSegmentProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchCustomerSegmentContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchCustomerSegmentContext.Provider>
  );
};

export default SearchCustomerSegmentProvider;
